// extracted by mini-css-extract-plugin
export default {"payments":"pe-z","header":"qe-z","adjustMarginAndPaddingNewDesign":"re-z"};